import {
  ActionButton,
  ButtonColumn,
  DateColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { ClinicPub } from '../../core/models/clinic-pub.model';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';
import { UsersTableConfigBuilder } from '../../user/config/user-search.config';

export class ClinicsTableConfigBuilder extends TableConfigBuilder<ClinicPub> {
  private clinicDeleteFunc: ((clinicId: string, event?: any) => void) | undefined;

  getColumns() {
    if (this.getFunction('onEditClinic') == undefined) {
      return [];
    }

  
    const columns = [
      new TextColumn({
        name: 'Επωνυμία',
        propertyName: 'clinicName',
      }),
      new TextColumn({
        name: 'Νοσοκομείο',
        propertyName: 'hospitalName'
      }),
      new TextColumn({
        name: 'Ιδιωτική',
        propertyName: 'isPrivateLiteral'
      }),
      new DateColumn({
        name: 'Ημ. Δημιουργίας',
        propertyName: 'dateInserted'
      }),
      new DateColumn({
        name: 'Ημ. Τροποποίησης',
        propertyName: 'dateModified'
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-pencil p-warning',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Επεξεργασία Κλινικής',
          tooltipPosition: 'bottom',
        },
        action: (item) => {
          this.getFunction('onEditClinic', item);
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-trash p-danger',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Διαγραφή Κλινικής',
          tooltipPosition: 'bottom',
        },
        action: (item?: ClinicPub, event?: any) => {
          if (this.clinicDeleteFunc) {
            this.clinicDeleteFunc(item?.id ?? '', event);
          }
        },
      })
    ];

    return columns;
  }

  getTable(data: ClinicPub[]): TableConfig<ClinicPub> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }

  addClinicDeleteFunction(
    clinicDeleteFunc: (clinicId: string, event?: any) => void
  ): ClinicsTableConfigBuilder {
    this.clinicDeleteFunc = clinicDeleteFunc;
    return this;
  }

}
